"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.branchRoutes = void 0;
const branchActions_openapi_1 = require("./branchActions.openapi");
exports.branchRoutes = [
    {
        name: 'branch.list',
        path: ['/', '/q/:q'],
        method: 'GET',
        plugins: {
            openapi: branchActions_openapi_1.branchOpenApiDocs['branch.list']
        }
    },
    {
        name: 'branch.create',
        path: ['/'],
        method: 'POST',
        plugins: {
            openapi: branchActions_openapi_1.branchOpenApiDocs['branch.create']
        }
    },
    {
        name: 'branch.get',
        path: '/:id',
        method: 'GET',
        plugins: {
            openapi: branchActions_openapi_1.branchOpenApiDocs['branch.get']
        }
    },
    {
        name: 'branch.update',
        path: '/:id',
        method: 'PUT',
        plugins: {
            openapi: branchActions_openapi_1.branchOpenApiDocs['branch.update']
        }
    },
    {
        name: 'branch.delete',
        path: '/:id',
        method: 'DELETE',
        plugins: {
            openapi: branchActions_openapi_1.branchOpenApiDocs['branch.delete']
        }
    }
];
